const CUPFATE_VIEW_BASE = 'https://www.cupfate.com/view';

/** Seven-digit (or alphanumeric) view codes used on cupfate.com */
const VIEW_CODE_PATTERN = /^[A-Za-z0-9]{7}$/;

/**
 * Resolve the cupfate view code from a fortune/transaction record.
 */
export function extractFortuneViewCode(record = {}) {
  const candidates = [
    record.view_code,
    record.viewCode,
    record.code,
    record.fortune_code,
    record.cupfate_code,
    record.cupviz_code,
    record.short_code,
    record.transaction_code,
    record.transaction_id,
    record.fortune_id,
    record.id,
  ];

  for (const value of candidates) {
    if (value == null || value === '') continue;
    const str = String(value).trim();
    if (VIEW_CODE_PATTERN.test(str)) {
      return str;
    }
  }

  for (const value of candidates) {
    if (value == null || value === '') continue;
    const str = String(value).trim();
    if (/^\d{7}$/.test(str)) {
      return str;
    }
  }

  return null;
}

export function buildFortuneViewUrl(viewCode) {
  if (!viewCode) return null;
  return `${CUPFATE_VIEW_BASE}/${viewCode}`;
}

export function getFortuneViewUrl(record) {
  const code = extractFortuneViewCode(record);
  return buildFortuneViewUrl(code);
}
